<template>
    <div>
        <h1 class="w-full p-2 bg-aitems-700 text-gray-100 font-light tracking-wide">
            Dove sono le arpe?
        </h1>

        <section class="w-2/3 mx-auto mt-5 flex items-center">
            <label for="range" class="px-6 py-7">
                Range di Matricole:
            </label>
            <input type="text"
                   name="bottom"
                   class="w-1/4 border rounded text-lg px-6 py-4 mr-4 font-bold text-center"
                   v-model="bottom"
            >
            <input type="text"
                   name="top"
                   class="w-1/4 border rounded text-lg px-6 py-4 font-bold text-center"
                   v-model="top"
            >
            <button class="ml-2 py-5 btn is-aitems-700"
                    @click="fetch"
                    :class="loading ? 'loader': ''"
            >
                <i class="fas fa-search fa-lg"></i>
            </button>
        </section>

        <section class="mt-5 w-3/4 table mx-auto rounded border shadow-lg"
                 v-if="list.length > 0"
        >
            <div class="th tr">
                <div class="td">Data</div>
                <div class="td">Matricola</div>
                <div class="td">Arpa</div>
                <div class="td">Modello</div>
                <div class="td">Cliente</div>
                <div class="td"># Doc. Vendita</div>
            </div>
            <div class="row" v-for="item in list">
                <div class="tr">
                    <div class="td">{{ item.data }}</div>
                    <div class="td">{{ item.matricola }}</div>
                    <div class="td">{{ item.des_articolo }}</div>
                    <div class="td">{{ item.des_config }}</div>
                    <div class="td">{{ item.ragione_sociale }}</div>
                    <div class="td">{{ item.doc_vendita }}</div>
                </div>
            </div>

        </section>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                bottom: '',
                top: '',
                list: {},
                domain: process.env.MIX_API_DOMAIN,
                loading: false
            }
        },

        methods: {
            fetch() {
                if (this.top === '' || this.bottom === '') {
                    swal.fire('Errore', 'I campi devono essere entrambi valorizzati', 'error'); //MAGARI DA SOSITUIRE CON L'ALTRO ALERT
                    return;
                }
                this.loading = true;
                axios.get(`${this.domain}/produzione/harps/history/range/${this.bottom}/${this.top}`)
                    .then(({data}) => {
                        this.loading = false;
                        if (data.data.length === 0) {
                            this.$toastr.e("La ricerca non fornisce nessun risultato :(");
                            return;
                        }
                        this.list = data.data;
                    });
            }
        }
    }
</script>

